import type { StandardSchemaV1 } from "@standard-schema/spec";
import type { AxiosInstance, AxiosResponse } from "axios";
import type { ResponseSchema } from "./types";
import { uuid } from "kdc-shared";

function validate(schema: StandardSchemaV1, data: unknown, part: "header" | "response", errorMsg: string) {
  const result = schema["~standard"].validate(data);

  const handleResult = (res: StandardSchemaV1.Result<unknown>) => {
    if (res.issues && res.issues.length > 0) {
      console.error(`validate ${part} failed(${errorMsg}):`, res.issues, "data is", data);
      throw new Error(errorMsg);
    }
  };

  if (result instanceof Promise) {
    return result.then(handleResult);
  }
  return handleResult(result);
}

function validateResponse(resp: AxiosResponse<any, any>) {
  const responseSchema = (resp.config as any).responseSchema as ResponseSchema | undefined;
  if (!responseSchema) {
    return resp;
  }

  if (responseSchema.headers) {
    validate(responseSchema.headers, resp.headers, "header", "返回头不符合预期");
  }

  if (responseSchema.response) {
    // debugger
    validate(responseSchema.response, resp.data, "response", "返回数据不符合预期");
  }

  return resp;
}

export function validateResponsePlugin(axios: AxiosInstance) {
  axios.interceptors.response.use(validateResponse, e => Promise.reject(e));
}

export function assignRequestIdPlugin(header: string | string[] = "X-KSC-Request-Id") {
  function hasRequestHeader(headers: any) {
    if (Array.isArray(header)) {
      for (let i = 0; i < header.length; ++i) {
        if (headers[header[i]!]) {
          return true;
        }
      }
      return false;
    }

    return !!headers[header];
  }

  function getRequestHeader() {
    return Array.isArray(header) ? header[0] : header;
  }

  if (Array.isArray(header) && header.length < 1) {
    throw new Error("Please make sure there is one valid header at least");
  }

  return function realAssignRequestIdPlugin(axios: AxiosInstance) {
    axios.interceptors.request.use(
      c => {
        const headers = c.headers ?? {};

        if (!hasRequestHeader(headers)) {
          headers[getRequestHeader()!] = uuid();
        }

        c.headers = headers;
        return c;
      },
      e => Promise.reject(e),
    );
  };
}